import React from 'react';

import { Collapse, Checkbox, Typography } from 'antd';

import { useIntl } from 'react-intl';

export const DownloadFolderSettingCollapse = (props) => {
  const { items, children = () => null } = props;

  return (
    <Collapse expandIconPosition='right' ghost>
      {items.map(children)}
    </Collapse>
  );
};

const DownloadFolderSettingPanel = (props) => {
  const intl = useIntl();

  const { item, status, onCheck, children, strong, ...restProps } = props;

  const onClickCheckbox = (e) => {
    e.stopPropagation();
  };

  const onChange = (e) => {
    onCheck && onCheck(item, e.target.checked);
  };

  return (
    <Collapse.Panel
      {...restProps}
      className='download-folder__product-setting-hierarchy'
      key={item}
      forceRender
      header={
        <Checkbox
          checked={status === 'checked'}
          indeterminate={status === 'indeterminate'}
          onClick={onClickCheckbox}
          onChange={onChange}
        >
          <Typography.Text
            strong={strong}
            style={{ marginLeft: -8, paddingLeft: 8 }}
            onClick={(e) => e.stopPropagation()}
          >
            {intl.formatMessage({
              id: `Taco.folder.download.configuration.${item}`,
            })}
          </Typography.Text>
        </Checkbox>
      }
    >
      {children}
    </Collapse.Panel>
  );
};

DownloadFolderSettingCollapse.Panel = DownloadFolderSettingPanel;

export default DownloadFolderSettingCollapse;
